<template>
  <div class="card-form">
    <el-form label-width="50px" size="mini" label-position="left" :model="form">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label-width="0px">
            <dict-select
              v-model="form.types"
              :body="{ dictType: 'amzOrderType' }"
              url="/sys/common/dict/system"
              :options="{ label: 'value', value: 'value' }"
              :placeholder="$l('form_placeholder_select_type') || '请选择类型'"
              multiple
              filterable
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="0px">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              range-separator="-"
              :start-placeholder="$l('INDEX.label_beginDate') || '开始日期'"
              :end-placeholder="$l('INDEX.label_endDate') || '结束日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label-width="0px">
            <el-input
              v-model="form.keyword"
              :placeholder="
                $l('form_label_Productnumberorname') || '产品编号/名称'
              "
              clearable
              type="search"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label-width="0px">
            <dict-select
              v-model="form.regionCodeList"
              :body="{ dictType: 'region' }"
              url="/master/common/dict/biz"
              :placeholder="$l('form_label_selectregionname ') || '市场'"
              filterable
              clearable
              multiple
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="0px">
            <dict-select
              v-model="form.storeCodeList"
              url="/ecom/amz/store/select"
              :placeholder="$l('form_label_selectstorename') || '请选择门店'"
              filterable
              clearable
              multiple
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-radio-group v-model="form.isQuantity" size="mini">
            <el-radio-button label="true"
              >{{ $l('table_label_quantity') || '销售'
              }}<i class="el-icon-bottom icon_left"></i
            ></el-radio-button>
            <el-radio-button label="false"
              >{{ $l('table_label_USD') || '美元'
              }}<i class="el-icon-bottom icon_left"></i
            ></el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="4">
          <el-button size="mini" type="primary" @click="getData()">{{
            $l('INDEX.btn_screen') || '筛选'
          }}</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="openAdvqueryDialog"
            plain
          >
            {{ $l('form_label_Exportdata') || '导出数据' }}</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import dayjs from '@/libs/util.date'
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: true,
      form: {
        types: ['Order'],
        isQuantity: true,
      },
      dateRange: [],
    }
  },
  mounted() {
    this.nowMonth()
    this.getData()
  },
  watch: {
    dateRange(val) {
      const [begin, end] = val || []
      this.form.beginDate = begin
      this.form.endDate = end
    },
  },
  methods: {
    // getData({ isQuantity = true, isProductSales = false } = {}) {
    getData() {
      if (!this.checkDateRange()) {
        this.$message.warning('日期范围不能超过180天')
        return
      }
      this.loading = true
      this.$api
        .orderboardadvListApi({
          ...this.form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.tableData.forEach((t) => {
            t.parentId = null
            t.hasChild = true
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkDateRange() {
      if (!this.form.beginDate || !this.form.endDate) {
        return true
      }
      const beginDate = dayjs(this.form.beginDate)
      const endDate = dayjs(this.form.endDate)
      return endDate.diff(beginDate, 'd') <= 180
    },
    nowMonth() {
      const endTime = dayjs().format('YYYY-MM-DD')
      const startTime = dayjs()
        .subtract(1, 'month')
        .format('YYYY-MM-DD')
      this.form.beginDate = startTime
      this.form.endDate = endTime
      this.dateRange = [startTime, endTime]
    },
    openAdvqueryDialog() {
      this.$refs.header.openAdvqueryDialog({
        dateRange: this.dateRange,
        ...this.form,
      })
    },
  },
}
</script>
<style scoped>
.icon_left {
  margin-left: 2px;
}
</style>
